import { useMutation, useQueryClient } from "@tanstack/react-query";

import { ORGANIZATION_MULTISIG_QUERY_KEY } from "@/apiQueries/multisigEnrollment/useOrganizationMultisig";
import { unenrollmentRequest } from "@/apiQueries/multisigUnenrollment/multisigUnenrollmentRequest";
import {
  MULTISIG_UNENROLLMENT_QUERY_KEY,
  MULTISIG_UNENROLLMENT_URL,
} from "@/apiQueries/multisigUnenrollment/useMultisigUnenrollment";

import type { UnenrollmentError } from "@/helpers/unenrollmentErrors";

import type { MultisigUnenrollmentStatus } from "@/types";

export const useMultisigUnenrollmentSubmitSignature = () => {
  const queryClient = useQueryClient();

  return useMutation<
    MultisigUnenrollmentStatus,
    UnenrollmentError,
    { txId: string; signerPublicKey: string; signedXdr: string }
  >({
    mutationFn: (vars) =>
      unenrollmentRequest<MultisigUnenrollmentStatus>(`${MULTISIG_UNENROLLMENT_URL}/signatures`, {
        method: "POST",
        body: JSON.stringify({
          tx_id: vars.txId,
          signer_public_key: vars.signerPublicKey,
          signed_xdr: vars.signedXdr,
        }),
      }),
    onSuccess: () => {
      void queryClient.invalidateQueries({ queryKey: MULTISIG_UNENROLLMENT_QUERY_KEY });
      void queryClient.invalidateQueries({ queryKey: ORGANIZATION_MULTISIG_QUERY_KEY });
      void queryClient.invalidateQueries({ queryKey: ["users"] });
    },
  });
};
